export default __webpack_public_path__ + "static/service-app-2e7e71f23f1ac459ec685d0ff5970229.png";